import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { Destination } from '../../DataStructures/Destination/Destination';
import { Trip } from '../../DataStructures/Trip/Trip';
import { Area } from '../../DataStructures/Area/Area';
import { MapControls } from '../../utilities/MapControls/MapConrols';
import { DirectionsService } from '../../utilities/DirectionsService/DirectionsService';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';
import { MatDialog, throwMatDialogContentAlreadyAttachedError } from '@angular/material';
declare var google: any;
@Component({
  selector: 'location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.css']
})


export class LocationPickerComponent implements OnInit {


  @ViewChild('map') mapReference: ElementRef;
  @Output() locationSelected = new EventEmitter<Array<LocationData>>();
  @Input() options : LocationOptions;
  locAddress:string;
  typedAddress = "";
  search;
  autocomplete;

  jaLat = 18.1350138;
  jaLng = -77.1981928;
  Width;
  locations = new Array<LocationData>();
  THIS;
  constructor(private directionsService:DirectionsService, public mapControls:MapControls, private dialog: MatDialog) {

    this.Width = (window.screen.width);
  }

  ngOnInit() {
    
  }

  setAddress(locationData){
    this.typedAddress = locationData.address;
    this.mapControls.addMarker(new google.maps.LatLng(locationData.lat,locationData.lng), "", true, 'usermarker4.png').addListener('click',function(){
    });
    this.locationSelected.emit([locationData])
  }

  ngAfterViewInit(): void {

    this.THIS = this;
    this.mapControls.initialize(this.mapReference);

    if (this.Width <= 600) {
      this.mapControls.createMapAndCenterOnLoaction(this.jaLat, this.jaLng,true);
    }else{
      this.mapControls.createMapAndCenterOnLoaction(this.jaLat, this.jaLng);
    }

    this.mapControls.map.setZoom(7);
    this.latLngOnClick()
    this.initAutoComplete();

    if(this.options.defaultLocations && this.options.defaultLocations.length > 0){
      this.options.defaultLocations.forEach(location =>{
        this.validateLocation(location,false,location.address);
      });
    }
  }

  buttonCallback(button:any){
    button.callback(this,button.extras);
  }

  removeLocation(locationData:LocationData){
    var index = this.locations.indexOf(locationData);
    if(index > -1){
      this.locations.splice(index,1);
    }
  }

  latLngOnClick() {

    this.mapControls.registerListener('click').then(e => {
      this.latLngOnClick();
      var loc = new LocationData("",e.latLng.lat(),e.latLng.lng());
      this.validateLocation(loc,false);
    }).catch(e => {
      this.latLngOnClick();
    })
  }

  initAutoComplete() {
    this.search = document.getElementById('search');
    this.autocomplete = new google.maps.places.Autocomplete(this.search, this.getOptions());
    this.regAutoCompleteListener();
  }

  getOptions() {
    var defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(17.546889258900055, -78.54058735825066),
      new google.maps.LatLng(18.591323377300697, -76.02471821762566)
    )
    return {
      bounds: defaultBounds
    };
  }

  regAutoCompleteListener(){

    this.mapControls.registerAutcompleteListener('place_changed',this.autocomplete).then(place =>{
      var loc = new LocationData("",place.geometry.location.lat(),place.geometry.location.lng());
      this.validateLocation(loc, true);
      this.regAutoCompleteListener();
    }).catch(e =>{
      this.regAutoCompleteListener();
    })
  }

  validateLocation(locationData:LocationData,fromSearch: boolean,prevAddress = null) {

    var dest = new Destination(locationData.lat, locationData.lng, "", null)
    var validTrip = new Trip(this.getTestOrigins(), new Area(1, "User Selected Location",null, [dest], false), [],null);
    var invalid = false;
    validTrip.getDirectionsGoogle(this.directionsService,null).then(res => {
      locationData.address = res.directions.routes[0].legs[0].end_address;
      locationData.lat = res.directions.routes[0].legs[0].end_location.lat();
      locationData.lng = res.directions.routes[0].legs[0].end_location.lng();
      locationData.id = locationData.id;
      this.locationValid(locationData, fromSearch,prevAddress);
    }).catch(e => {
      this.locationInvalid();
    })
  }

  locationValid(locationData:LocationData, fromSearch: boolean,prevAddress = null) {

    var THIS = this;
    this.locAddress = this.decideLocAddress(prevAddress,locationData.address);
    var searchInput : any = document.getElementById('search');
    locationData.address = searchInput.value;
    if(this.options.multipleLocations){
      var marker = this.mapControls.addMarker(new google.maps.LatLng(locationData.lat,locationData.lng), "", false, 'usermarker4.png');
      marker.addListener('click',function(){
        THIS.options.markerClickedCallBack(locationData,marker,THIS)
      });
    
    }else{
      this.mapControls.addMarker(new google.maps.LatLng(locationData.lat,locationData.lng), "", true, 'usermarker4.png').addListener('click',function(){
        THIS.options.markerClickedCallBack(locationData,marker,THIS)
      });
    }

    if (fromSearch) {
      this.mapControls.centerMapOnLoaction(new google.maps.LatLng(locationData.lat,locationData.lng));
    }

    if(this.options.multipleLocations){
      this.locations.push(locationData);
      this.locationSelected.emit(this.locations);
    }else{
      this.locationSelected.emit([locationData])
    }
  }

  private decideLocAddress(prevAddress = null,end_address){

    if(this.options.finalLocationFromSearchBar){
      if(this.search.value){
        return this.search.value;
      }else if(prevAddress){
        return prevAddress;
      }else{
        return end_address;
      }
    }else{
      return end_address;
    }
  }

  locationInvalid() {
    new QuickDialog(this.dialog).InfoDialog("Location Not Allowed, Please select a location within Jamaica","Invalid Location","OK");
    let jaLat = 18.9350138;
    let jaLng = -77.7981928;

    this.mapControls.clearMarkers();
    this.search.value = null;
    this.mapControls.centerMapOnLoaction(new google.maps.LatLng(this.jaLat, this.jaLng));
    this.mapControls.map.setZoom(7);
  }

  getTestOrigins() {


    var destination = new Destination(18.0418764, -76.7772811, "", null);
    var destinations = new Array<Destination>();
    destinations.push(destination);
    return new Area(
      -1,
      "Russell Heights, Kingston, Jamaica",
      null,
      destinations,
      true
    );
  }
}

export interface LocationOptions{
  searchBoxText?:string,
  passengerMode?:boolean,
  defaultLocations?:Array<LocationData>,
  finalLocationFromSearchBar?:boolean,
  multipleLocations?:boolean,
  markerClickedCallBack?:(locationData:LocationData,marker:any,picker:LocationPickerComponent) => void,
  title?:string,
  subtitle?:string,
  showLocationBelowTitle?:boolean,
  buttons?:Array<{
    "text":string,
    "callback":(picker:LocationPickerComponent,extras:Map<string,any>) => void,
    "extras":Map<string,any>
  }>
}

export class LocationData{
  id:number;
  address:string;
  lat:number;
  lng:number;

  constructor(address:string,lat:number,lng:number,id:number = null){
    this.address = address;
    this.lat = lat;
    this.lng = lng;
  }
}
